<template>
  <svg
    width="24"
    height="27"
    viewBox="0 0 24 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.78981 0L1.7121 6.79642V10.2664H3.20449V7.79037H8.87598V1.44926H20.7924V10.2666H22.2859V0.0005753L7.78981 0Z"
      fill="currentcolor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.20265 20.8529H20.7925V25.5507L3.20265 25.534V20.8529ZM5.59117 13.2529C7.16598 13.2529 8.30719 14.4513 8.33702 16.0685C8.36466 17.5531 7.47716 19.0042 5.77904 19.0042H3.29924L3.29898 13.2529H5.59117ZM18.1248 13.0642C18.3579 13.0595 18.5936 13.0816 18.8201 13.1289C19.9884 13.362 20.5687 14.1493 20.7017 15.141H19.4622C19.3415 14.5309 18.7284 14.0479 18.0819 14.105C17.6105 14.1071 17.1509 14.3691 16.9503 14.7883C16.6282 15.4188 16.6282 16.158 16.7309 16.8387C16.8148 17.3487 17.0736 17.9307 17.6241 18.0785C18.5225 18.3251 19.2611 17.9703 19.4622 17.0274H20.7017C20.5551 17.8633 20.0315 18.6736 19.2015 19.0042C18.4263 19.3101 17.5008 19.2589 16.7651 18.8734C15.9162 18.4137 15.4708 17.471 15.4251 16.5567C15.3611 15.6024 15.5168 14.5723 16.2208 13.8271C16.712 13.3083 17.4213 13.0735 18.1248 13.0642ZM11.8071 13.062C12.1451 13.0582 12.4861 13.1004 12.8083 13.1865C13.453 13.3573 14.0127 13.7939 14.3049 14.378C14.7421 15.2279 14.7834 16.2219 14.6188 17.1425C14.4832 17.897 14.017 18.6199 13.2788 18.9378C12.8425 19.1355 12.3553 19.204 11.8774 19.204C11.0544 19.2146 10.1696 18.9574 9.65382 18.2988C9.06129 17.5549 8.97926 16.5593 9.05912 15.6561C9.1328 14.8369 9.48436 13.9917 10.2069 13.5193C10.677 13.2107 11.2396 13.0689 11.8071 13.062ZM0 11.4133V20.8521H1.71175V26.9804L22.2857 27V20.8525H24V11.4131L0 11.4133Z"
      fill="currentcolor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.8687 14.1274C11.3955 14.1299 10.9224 14.3029 10.6482 14.6914C10.2299 15.2831 10.2162 16.0491 10.2865 16.7393C10.3439 17.2433 10.5796 17.7822 11.0778 18.0084C11.3249 18.1286 11.6032 18.1724 11.8775 18.1724C12.452 18.1929 13.0187 17.864 13.2517 17.3519C13.5467 16.7328 13.5287 16.0142 13.393 15.3568C13.2833 14.8247 12.9045 14.3032 12.33 14.1809C12.1816 14.1457 12.0241 14.1249 11.8687 14.1274Z"
      fill="currentcolor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.50326 14.2498V18.0264H5.52771C6.57622 18.0264 7.07487 17.1501 7.06999 16.0693C7.06819 15.0085 6.62224 14.2498 5.4197 14.2498L4.50326 14.2498Z"
      fill="currentcolor"
    />
  </svg>
</template>
